import { useCallback, useState } from "react";
import CustomButton from "../../../../components/CustomButton";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../helpers/apiHelper";
import ModalWrapper from "../../../../components/Modal/ModalWrapper";
import Text from "../../../../styleguide/Text";
import {
  fetchCargoCarPickupCargoInternodeRoute,
  postClosePackageCargoInternode,
} from "../../../../redux/api/raports.api";
import {
  clearPickupCargoInternodeRoute,
  closePackageCargoInternodeRouteModal,
  setSelectedCargoInternodeItemForClosing,
} from "../../../../redux/reducer/raports.reducer";
import DateTimePicker from "../../../../components/misc/DateTimePicker";
import { dateAndTimeForDatabase } from "../../../../utils/dateAndTime";

export interface SelectedItemCargoInternodeForClosingInterface {
  id: number | string;
  type: "COLET" | "BIN";
  label?: string;
}

function ClosePackageCargoInternodeModal({
  id_ruta_intranod,
  id_nod_curent,
  id_nod_start,
  id_nod_stop,
}: {
  id_ruta_intranod?: string | number | undefined;
  id_nod_curent?: string | number | undefined;
  id_nod_start?: string | number | undefined;
  id_nod_stop?: string | number | undefined;
}) {
  const dispatch = useAppDispatch();
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const {
    raports: {
      isClosePackageCargoInternodeRouteModalOpen,
      selectedItemCargoInternodeForClosing,
    },
  } = useAppSelector((state) => ({
    raports: state.raports,
  }));

  const [isLoading, setIsLoading] = useState(false);

  const handleOnSubmit = useCallback(async () => {
    if (!selectedItemCargoInternodeForClosing || !selectedDate) return;

    setIsLoading(true);

    const payload: any = {
      data_finalizarii: dateAndTimeForDatabase(selectedDate),
    };

    if (selectedItemCargoInternodeForClosing.type === "BIN") {
      payload.id_bin = selectedItemCargoInternodeForClosing.id;
    } else {
      payload.id_doctrans_detl = selectedItemCargoInternodeForClosing.id;
    }

    const resultAction = await dispatch(
      postClosePackageCargoInternode(payload),
    );

    if (
      checkEndpointStatus(resultAction, postClosePackageCargoInternode) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, postClosePackageCargoInternode) ===
      endpointStatus.fulfilled
    ) {
      dispatch(clearPickupCargoInternodeRoute());

      dispatch(
        fetchCargoCarPickupCargoInternodeRoute({
          id_ruta_intranod,
          id_nod_curent,
          id_nod_start,
          id_nod_stop,
        }),
      );

      setSelectedDate(null);
      dispatch(setSelectedCargoInternodeItemForClosing(null));
      dispatch(closePackageCargoInternodeRouteModal());
    }
  }, [
    dispatch,
    selectedItemCargoInternodeForClosing,
    selectedDate,
    id_ruta_intranod,
    id_nod_curent,
    id_nod_start,
    id_nod_stop,
  ]);

  const handleClose = () => {
    dispatch(closePackageCargoInternodeRouteModal());
    setSelectedDate(null);
  };

  const isBin = selectedItemCargoInternodeForClosing?.type === "BIN";

  const modalTitle = selectedItemCargoInternodeForClosing
    ? `${isBin ? "Inchidere bin" : "Inchidere colet"} ${
        selectedItemCargoInternodeForClosing.label ?? ""
      }`
    : isBin
    ? "Inchidere bin"
    : "Inchidere colet";

  return (
    <ModalWrapper
      show={!!isClosePackageCargoInternodeRouteModalOpen}
      title={modalTitle}
      modalSize="md"
      handleClose={handleClose}>
      <DateTimePicker
        label="Data si ora inchiderii"
        value={selectedDate}
        maxDate={new Date()}
        handleChangeDate={(newDate) => setSelectedDate(newDate)}
      />

      <CustomButton
        type="submit"
        variant="contained"
        fullWidth
        className="btn btn-lg btn-primary w-100 mt-5"
        disabled={!selectedItemCargoInternodeForClosing || !selectedDate}
        loading={isLoading}
        onClick={handleOnSubmit}>
        <Text variant="body1" isBold>
          Salveaza
        </Text>
      </CustomButton>
    </ModalWrapper>
  );
}

export default ClosePackageCargoInternodeModal;
